//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QRCode from 'qrcode';
import { getPaymentResult } from '~/api/index';
const exp = 300;
export default {
  props: {
    detail: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      QRExpireSeconds: exp,
      setInTime: null,
      timer: 0,
    };
  },
  computed: {
    second() {
      const val = String(this.QRExpireSeconds % 60);
      return val.padStart(2, '0');
    },
    minute() {
      const val = String(Math.floor(this.QRExpireSeconds / 60));
      return val.padStart(2, '0');
    },
  },
  watch: {
    detail(val) {
      if (val) {
        this.initQrcode();
        this.initInterval();
      }
    },
  },
  mounted() {
    this.initQrcode();
    this.initInterval();
  },
  beforeDestroy() {
    this.timer = 0;
    clearInterval(this.setInTime);
    this.QRExpireSeconds = exp;
  },
  methods: {
    /**
     * @description 判断订单是否支付成功
     */
    async polling(orderId) {
      const res = await this.$axios(getPaymentResult(orderId));
      if (res.statusCode === 200) {
        if (res.result.payStatus === 'success') {
          return res;
        } else if (res.result.payStatus === 'failed') {
          return false;
        }
        return false;
      }
      return false;
    },
    /**
     * @description 生成新的订单
     */
    async createQrcode() {
      await this.$emit('newQrcode');
    },
    initInterval() {
      const self = this;
      self.QRExpireSeconds = exp;
      this.setInTime = setInterval(async () => {
        // 时间计时
        if (self.QRExpireSeconds > 0) {
          self.timer++;
          self.QRExpireSeconds--;
          if (self.timer % 5 === 0) {
            const data = await self.polling(self.detail.orderNo);
            if (data) {
              clearInterval(self.setInTime);
              self.timer = 0;
              this.$emit('paysuccess');
              return true;
            }
          }
        } else {
          self.timer = 0;
          clearInterval(self.setInTime);
        }
      }, 1000);
    },
    /**
     * @description 生成支付二维码
     */
    initQrcode() {
      const qrcode = document.getElementById('qrcode');
      QRCode.toCanvas(qrcode, String(this.detail.credential.wx_pub_qr));
    },
  },
};
